import { Component, OnInit, AfterViewInit, OnDestroy, ElementRef, ViewChild, NgZone } from '@angular/core';
import { CarouselConfig } from 'ngx-bootstrap/carousel';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  providers: [
    { provide: CarouselConfig, useValue: { interval: 2500, noPause: false, showIndicators: false } }
  ],
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('heroVideo') heroVideo: ElementRef<HTMLVideoElement>;

  noWrapSlides = false;
  showIndicator = true;
  disabled = false;
  max = 20000;
  min = 0;
  step = 5;
  transationSlider = 50;
  // Denefits 360 hero slide (replaces the old image/mock slides, which are
  // parked in the ng-template of the template file)
  hero = {
    videoUrl: 'https://denefits.s3.us-west-1.amazonaws.com/Denefits360.mp4',
    eyebrow: 'DENEFITS TERMINAL',
    titleTop: 'One Checkout,',
    titleBottom: 'Every way to Pay.'
  };
  slides = [
    { image: 'assets/img/png/No_fee.png', text: 'No Fee Payment Processing' },
    // { image: 'assets/img/png/carousel_1.png', text: 'Flexible Payment Plans' },
    { image: 'assets/img/png/flexible_plan_carousel.png', text: 'Automated Account Receivable' },
  ]
  private readonly maxVideoRetries = 5;
  private videoRetries = 0;
  private videoCleanup: Array<() => void> = [];

  constructor(private el: ElementRef, private zone: NgZone) {}
  ngOnInit() {
  }

  ngAfterViewInit() {
    const indicators: NodeListOf<HTMLElement> =
      this.el.nativeElement.querySelectorAll('.carousel-indicators button');

    indicators.forEach((btn: HTMLElement) => {
      btn.setAttribute('data-bs-target', '#carousel1'); // force static target
    });

    this.setupHeroVideo();
  }

  ngOnDestroy() {
    this.videoCleanup.forEach(remove => remove());
    this.videoCleanup = [];
  }

  /**
   * Browsers block autoplay unless the element is muted, and they also drop
   * playback when the tab starts hidden or the network stalls. So instead of
   * relying on the `autoplay` attribute alone, keep asking the video to play
   * whenever it becomes possible.
   */
  private setupHeroVideo() {
    const video = this.heroVideo && this.heroVideo.nativeElement;
    if (!video) {
      return;
    }

    // Property (not just attribute) — this is what the autoplay policy reads.
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;

    // Listeners live outside Angular: they must not trigger change detection.
    this.zone.runOutsideAngular(() => {
      const on = (target: EventTarget, event: string, handler: EventListener) => {
        target.addEventListener(event, handler, event === 'scroll' ? { passive: true } : undefined);
        this.videoCleanup.push(() => target.removeEventListener(event, handler));
      };

      const tryPlay = () => {
        const played = video.play();
        if (played && typeof played.catch === 'function') {
          // Blocked for now — a later event or the first user gesture retries.
          played.catch(() => undefined);
        }
      };

      const reload = () => {
        if (this.videoRetries >= this.maxVideoRetries) {
          return;
        }
        this.videoRetries++;
        video.load();
        tryPlay();
      };

      on(video, 'loadeddata', tryPlay);
      on(video, 'canplay', tryPlay);
      on(video, 'stalled', reload);
      on(video, 'error', reload);
      on(document, 'visibilitychange', () => {
        if (!document.hidden) {
          tryPlay();
        }
      });

      // Last resort: the first interaction anywhere on the page satisfies the
      // gesture requirement on the strictest autoplay settings.
      ['click', 'keydown', 'touchstart'].forEach(event => on(document, event, tryPlay));

      tryPlay();
    });
  }
}
